/**
 * Сборка платформы: каркас `web-shell` + единственный экран платформы
 * (§13.3). Это первая из трёх сборок, о которых говорит §13.1 («три
 * сборки, один шелл»); две другие соберут обучающий и финансовый сервисы,
 * взяв отсюда каркас, но не этот экран.
 *
 * Человек, вошедший, но не являющийся владельцем, увидит здесь экран
 * отказа §6.4 — не пустую страницу и не «раздел в разработке». Отказ
 * приходит с сервера (403), интерфейс его только показывает.
 */

import { Denied } from './shell';
import { AppShell } from './shell';
import { UsersAndAccess } from './screens/UsersAndAccess';

export function App() {
  return (
    <AppShell title="Тоскана — пользователи и доступ">
      {(me) => (me.is_host ? <UsersAndAccess meUserId={me.user_id} /> : <Denied />)}
    </AppShell>
  );
}
